<template>
  <div class="file-error-placeholder">
    <svg width="24">
      <use xlink:href="#error" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.file-error-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-button-default);
  border-radius: 4px;
}
</style>
